import { Component, OnInit } from "@angular/core";

import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AuthService } from "src/app/_app-core/services/auth/auth.service";

@Component({
    selector: "app-impersonate",
    templateUrl: "./impersonate.component.html",
    styleUrls: ["./impersonate.component.scss"],
})
export class ImpersonateComponent implements OnInit {
    sessionId: any;
    code: any;
    adminName: any;
    adminEmail: any;
    responseData;

    constructor(
        private router: Router,
        private http: HttpClient,
        private route: ActivatedRoute,
        private authService: AuthService
    ) {
        this.route.queryParams.subscribe((params) => {
            if (params["token"]) {
                const pathParams = params["token"];
                let pathSplit = pathParams.split("$$$");
                //console.log(pathSplit);
                this.sessionId = pathSplit[0];
                this.code = pathSplit[1];
                this.adminName = pathSplit[2];
                this.adminEmail = pathSplit[3];
            } else {
                this.router.navigateByUrl("/");
            }
        });
    }

    ngOnInit(): void {
        const reqData = {
            sellerCode: this.code,
            session: {
                sessionId: this.sessionId,
            },
        };

        this.authService.impersonate(reqData).subscribe(
            (res) => {
                this.responseData = res;
                if (this.responseData.status == "success") {
                    localStorage.setItem(
                        "userSession",
                        this.responseData.session.sessionId
                    );
                    localStorage.setItem(
                        "displayName",
                        this.responseData.user.displayName
                    );
                    localStorage.setItem(
                        "vendorCode",
                        this.responseData.user.sellerCode
                    );
                    localStorage.setItem(
                        "logisticFlag",
                        this.responseData.user.logistics_flag
                    );
                    localStorage.setItem(
                        "nonPoFlag",
                        this.responseData.user.non_po_flag
                    );
                    localStorage.setItem("impersonation", "true");
                    localStorage.setItem("adminUser", this.adminName);
                    localStorage.setItem("adminEmail", this.adminEmail);

                    setTimeout(() => {
                        this.router.navigateByUrl("dashboard");
                    }, 4000);
                } else {
                    console.log(this.responseData.msg);
                }
            },
            (error) => {}
        );
    }
}
